// React
import i18n from 'i18next';

// Config
import { appConfig } from '../../model/context/app/app';

// Config
const config: DateConfig = {
    time: {
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: false,
    },
    dateShort: {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    },
    dateLong: {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: false,
    },
};

// Types
interface DateConfig {
    time: Intl.DateTimeFormatOptions;
    dateShort: Intl.DateTimeFormatOptions;
    dateLong: Intl.DateTimeFormatOptions;
}

type DateTransformType = 'time' | 'dateShort' | 'dateLong';

export default function dateToString(val: string, type: DateTransformType, timeZone?: string) {
    const date = new Date(val);
    const locale = appConfig.languages.includes(i18n.language) ? i18n.language : 'de-DE';
    const options = type ? { ...config[type], timeZone } : {};

    return date instanceof Date && !isNaN(Number(date)) ? Intl.DateTimeFormat(locale, options).format(date) : false;
}
